import React from 'react';
import AWS from 'aws-sdk';
import { AWS_S3_BUCKET, AWS_S3_ACCESS_KEY_ID, AWS_S3_SECRET_ACCESS_KEY } from '../../../constants';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import actions from '../../../redux/actions';
import Select from '../../Select';
import SpinnerComponent from '../../SpinnerComponent';

const bucket = process.env.REACT_APP_AWS_S3_BUCKET || AWS_S3_BUCKET;
const accessKeyId = process.env.REACT_APP_AWS_S3_ACCESS_KEY_ID || AWS_S3_ACCESS_KEY_ID;
const secretAccessKey = process.env.REACT_APP_AWS_S3_SECRET_ACCESS_KEY || AWS_S3_SECRET_ACCESS_KEY;

AWS.config.update({
  accessKeyId,
  secretAccessKey,
});
const S3 = new AWS.S3();
const S3_DOMAIN = `https://${bucket}.s3.amazonaws.com`;

const formatName = (name) => {
  // Get file extension first
  const lastDot = name.lastIndexOf('.');
  const ext = lastDot > -1 ? name.slice(lastDot) : '';
  const baseName = lastDot > -1 ? name.slice(0, lastDot) : name;

  // Process the base name
  const sanitized = baseName
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9-_.]/g, '-') // Replace special chars with hyphen
    .replace(/\s+/g, '-')          // Replace spaces with hyphen
    .replace(/-+/g, '-')           // Replace multiple hyphens with single hyphen
    .replace(/^-+|-+$/g, '')       // Remove hyphens from start and end
    .replace(/[^a-z0-9]$/, '');    // Remove last char if it's not alphanumeric

  return sanitized + ext;
};

class FileUploader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      isLoading: false,
    };
    this.onChange = this.onChange.bind(this);
    this.onWrapperClick = this.onWrapperClick.bind(this);
    this.uploadToS3 = this.uploadToS3.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.handleFileRemove = this.handleFileRemove.bind(this);
    this.onWrapperClick = this.onWrapperClick.bind(this);
  }

  uploadToS3 = async (file) => {
    if (file && file.size > 500 * 1024 * 1024) {
      this.props.alert('error', 'File size should be less than 500MB');
    }

    return S3.putObject({
      Bucket: bucket,
      Key: `deal_uploads/cosynd/static/temp/${this.props.coregId}/${formatName(file.name)}`,
      Body: file,
      ACL: 'public-read',
    }).promise().then((data) => {
      console.log('Successfully uploaded file:', data);
      this.props.alert('success', 'File uploaded successfully');
      this.setState({
        files: [
          ...this.state.files,
          {
            ...file,
            work_title: '',
            file_url: `${S3_DOMAIN}/deal_uploads/cosynd/static/temp/${this.props.coregId}/${formatName(file.name)}`,
            name: formatName(file.name),
          },
        ],
      })
    }).catch((err) => {
      console.error('Error uploading file:', err);
      this.props.alert('error', 'An error occurred. Please try again.');
    });
  };

  onWrapperClick = () => {
    if (!this.state.isLoading) {
      document.getElementById('file-uploader').click();
    }
  }

  onChange = async (e) => {
    const files = e.target.files;

    this.setState({ files: [], isLoading: true });

    await Promise.all(
      Array.from(files)
        .slice(0, this.props.workTitles.length)
        .map(this.uploadToS3)
    ).then(() => {
      this.setState({ isLoading: false });
      this.fileUploader.value = '';
    });
  };

  handleWorkTitle(e, fileIndex) {
    let { files } = this.state;

    files[fileIndex]['work_title'] = e.target.value;

    this.setState({ files });
  }

  handleUpload(e) {
    e.preventDefault();

    let { files } = this.state;

    if (files.length === 0) {
      this.props.alert('error', 'Please select files');
    }

    const checkedAll = files.every(({ work_title }) => work_title !== '');

    if (checkedAll) {
      let uploadFiles = [];
      files.forEach((file) => {
        uploadFiles = [
          ...uploadFiles,
          {
            file_url: file.file_url,
            work_title: file.work_title,
          },
        ];
      });

      this.props.onUpload(uploadFiles);
    } else {
      this.props.alert('error', 'Please select work titles');
    }
  }

  handleFileRemove(e, file) {
    e.preventDefault();
    const files = [...this.state.files].filter((item) => item.file_url !== file.file_url);
    this.setState({ files });
  }

  render() {
    const { fileUpload, workTitles } = this.props;
    const { files, isLoading } = this.state;

    return (
      <div className="relative file-upload">
        <div
          className="relative"
          onClick={this.onWrapperClick}
          style={isLoading ? {
            opacity: 0.5,
          } : {}}
        >
          <input
            ref={(ref) => (this.fileUploader = ref)}
            id='file-uploader'
            type='file'
            multiple={workTitles.length > 1}
            onChange={this.onChange}
            style={{ display: 'none' }}
          />
          {this.props.children}
        </div>
        {
          isLoading && (
            <SpinnerComponent
              containterStyleInline={{
                height: 20,
                margin: '20px 0',
              }}
            />
          )
        }
        {files.length > 0 && !isLoading && (
          <div className="files-view">
            {files.map((item, fileIndex) => (
              <div key={fileIndex} className="uploaded-file">
                <span>{item.name}</span>
                <Select
                  className="form-control"
                  value={item.work_title ? item.work_title : ''}
                  onChange={(e) => this.handleWorkTitle(e, fileIndex)}
                >
                  <option value="">Select Work Title</option>
                  {workTitles.map((work, index) => (
                    <option key={index} value={work.title}>
                      {work.title}
                    </option>
                  ))}
                </Select>
                <a
                  className="remove"
                  onClick={(e) => this.handleFileRemove(e, item)}
                >
                  <FontAwesome name="close" />
                </a>
              </div>
            ))}

            <button
              className="btn-upload"
              onClick={(e) => this.handleUpload(e)}
            >
              {fileUpload === 'start'
                ? 'Upload'
                : fileUpload === 'uploading'
                ? 'Uploading...'
                : 'Uploaded'}
            </button>
          </div>
        )}
      </div>
    )
  }
}

FileUploader.defaultProps = {
  children: null,
  fileUpload: 'start',
  workTitles: [],
};

FileUploader.propTypes = {
  children: PropTypes.node,
  fileUpload: PropTypes.string,
};

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
});

export default connect(null, mapDispatchToProps)(FileUploader);



// WEBPACK FOOTER //
// src/components/Common/FileUploader/index.jsx